// extracted by mini-css-extract-plugin
export var equalColumn = "_cw-0";